<ng-template #main><ng-content select="[main]"></ng-content></ng-template>
<ng-template #leftColumn><ng-content select="[leftColumn]"></ng-content></ng-template>
<ng-template #rightColumn><ng-content select="[rightColumn]"></ng-content></ng-template>

<ng-container *ngIf="!centered">
  <div class="vi-tabs-container flex flex-row justify-center items-center">
    <ng-content select="[tabs]"></ng-content>
  </div>
  <div *ngIf="fluid && !twoColumns" class="vi-content-item flex flex-col gap-[{{ gap }}]">
    <div class="w-full min-w-full h-full min-h-full flex-initial">
      <div
        class="flex flex-{{ direction }} gap-[{{ gap }}] {{
          layoutAlign
        }} w-full min-w-full h-full min-h-full"
        [class.flex-wrap]="wrap"
      >
        <div data-at-content-main class="vi-content-box flex-[100%] max-w-[100%]">
          <ng-container *ngTemplateOutlet="main"></ng-container>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="fluid && twoColumns" class="vi-content-item flex flex-col gap-[{{ gap }}]">
    <div class="flex-initial">
      <div class="flex flex-row justify-center items-start">
        <div
          class="vi-content-box flex flex-row sm:flex-col gap-[{{
            gap
          }}] items-start w-full min-w-full h-full min-h-full flex-[100%] max-w-[100%]"
        >
          <div
            class="vi-content-box__column flex flex-col gap-[{{
              gap
            }}] sm:flex-[100%] sm:max-w-[100%] flex-[{{ leftColumnWidth }}] max-w-[{{
              leftColumnWidth
            }}]"
          >
            <ng-container *ngTemplateOutlet="leftColumn"></ng-container>
          </div>
          <div
            class="vi-content-box__column flex flex-col gap-[{{
              gap
            }}] sm:flex-[100%] sm:max-w-[100%] flex-[{{ rightColumnWidth }}] max-w-[{{
              rightColumnWidth
            }}]"
          >
            <ng-container *ngTemplateOutlet="rightColumn"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!fluid && twoColumns" class="vi-content-item flex flex-col gap-[{{ gap }}]">
    <div class="flex-initial">
      <div class="flex flex-row justify-center items-start">
        <div
          class="customer-invitations flex flex-row xs:flex-col justify-between items-start lt-lg:flex-[100%] lt-lg:min-w-[100%] lt-lg:max-w-[100%]"
          [ngStyle]="{ 'max-width': contentWidth, 'min-width': contentWidth, flex: contentWidth }"
        >
          <div
            data-at-content-left
            class="flex flex-col gap-[{{
              gap
            }}] flex-[496px] max-w-[496px] xs:flex-[100%] xs:max-w-[100%] lt-lg:flex-[{{
              leftColumnWidth
            }}] lt-lg:max-w-[{{ leftColumnWidth }}]"
          >
            <ng-container *ngTemplateOutlet="leftColumn"></ng-container>
          </div>
          <div
            data-at-content-right
            class="flex flex-col gap-[{{
              gap
            }}] flex-[496px] max-w-[496px] xs:flex-[100%] xs:max-w-[100%] lt-lg:flex-[{{
              rightColumnWidth
            }}] lt-lg:max-w-[{{ rightColumnWidth }}]"
          >
            <ng-container *ngTemplateOutlet="rightColumn"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!fluid && !twoColumns" class="vi-content-item flex flex-col gap-[{{ gap }}]">
    <div class="w-full min-w-full h-full min-h-full flex-initial">
      <div class="flex flex-row justify-center items-start w-full min-w-full h-full min-h-full">
        <div
          data-at-content-main
          [class.flex-wrap]="wrap"
          class="vi-content-box flex flex-{{ direction }} gap-[{{ gap }}] {{
            layoutAlign
          }} lt-lg:!flex-[100%] lt-lg:!min-w-[100%] lt-lg:!max-w-[100%]"
          [ngStyle]="{ 'max-width': contentWidth, 'min-width': contentWidth, flex: contentWidth }"
        >
          <ng-container *ngTemplateOutlet="main"></ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="centered">
  <div *ngIf="fluid && !twoColumns" class="vi-content-item flex flex-col gap-[{{ gap }}]">
    <div class="w-full min-w-full h-full min-h-full flex-[100%] max-w-[100%]">
      <div
        class="flex flex-{{ direction }} gap-[{{ gap }}] {{
          layoutAlign
        }} w-full min-w-full h-full min-h-full"
        [class.flex-wrap]="wrap"
      >
        <div data-at-content-main class="vi-content-box flex-[100%] max-w-[100%]">
          <ng-container *ngTemplateOutlet="main"></ng-container>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!fluid && !twoColumns" class="vi-content-item flex flex-col gap-[{{ gap }}]">
    <div class="w-full min-w-full h-full min-h-full flex-[100%] max-w-[100%]">
      <div class="flex flex-row justify-center items-start w-full min-w-full h-full min-h-full">
        <div
          data-at-content-main
          [class.flex-wrap]="wrap"
          class="vi-content-box flex flex-{{ direction }} gap-[{{ gap }}] {{
            layoutAlign
          }} lt-lg:flex-[100%] lt-lg:max-w-[100%]"
          [ngStyle]="{ 'min-width': contentWidth, flex: contentWidth }"
        >
          <ng-container *ngTemplateOutlet="main"></ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-container>
